console.log("%cSite designed by Wren Digital | Learn more https://wren-digital.com", "font-size: 14px; color: #FF5C00;");

/* Rally native pack selector: default to 24-Pack on product page */
(() => {
  function selectDefault24Pack() {
    if (new URLSearchParams(window.location.search).has('variant') || window.location.hash) return;
    const scope = document.querySelector('.product__info-container .product__block--variant_picker');
    if (!scope) return;
    const radios = Array.from(scope.querySelectorAll('.product-form__input--button input[type="radio"]'));
    const target = radios.find((radio) => (radio.value || '').toLowerCase().includes('24-pack'));
    if (target && !target.checked) target.click();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => setTimeout(selectDefault24Pack, 150), { once: true });
  } else {
    setTimeout(selectDefault24Pack, 150);
  }
})();

/* Rally: stable effective subscription display */
(() => {
  const PACKS = {
    '12-Pack': {
      badge: '15% OFF',
      first: '15% off your first order',
      ongoing: '10% off every order after',
      compare: '$36.00',
      freeShipping: false
    },
    '24-Pack': {
      badge: '24% OFF',
      first: '24% off your first order',
      ongoing: '19% off every order after',
      compare: '$72.00',
      freeShipping: true
    },
    '48-Pack': {
      badge: '32% OFF',
      first: '32% off your first order',
      ongoing: '28% off every order after',
      compare: '$144.00',
      freeShipping: true
    }
  };

  const state = new WeakMap();

  function getPack(scope) {
    return scope.querySelector('.product-form__input--button input[type="radio"]:checked')?.value || null;
  }

  function getSubscriptionOption(scope) {
    return Array.from(scope.querySelectorAll('.appstle_subscription_wrapper_option'))
      .find((el) => /subscribe\s*&?\s*save/i.test(el.textContent || ''));
  }

  function setComparePrice(subOption, compare) {
    const oldValues = new Set(['$36.00', '$64.80', '$115.20', '$72.00', '$144.00']);

    const walker = document.createTreeWalker(subOption, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);

    nodes.forEach((node) => {
      const txt = (node.nodeValue || '').trim();
      if (!oldValues.has(txt)) return;

      const parent = node.parentElement;
      if (!parent) return;

      const ownStyle = getComputedStyle(parent);
      const parentStyle = parent.parentElement ? getComputedStyle(parent.parentElement) : null;
      const struck =
        ownStyle.textDecorationLine.includes('line-through') ||
        (parentStyle && parentStyle.textDecorationLine.includes('line-through')) ||
        parent.tagName === 'S' ||
        parent.tagName === 'DEL';

      if (struck) node.nodeValue = node.nodeValue.replace(txt, compare);
    });
  }

  function render(scope, generation) {
    if (!scope || state.get(scope) !== generation) return;

    const pack = getPack(scope);
    const cfg = PACKS[pack];
    if (!cfg) return;

    const subOption = getSubscriptionOption(scope);
    if (!subOption) return;

    subOption.dataset.rallyEffectivePack = pack;

    setComparePrice(subOption, cfg.compare);

    const oneTimeOption = Array.from(scope.querySelectorAll('.appstle_subscription_wrapper_option'))
      .find((el) => /one\s*time\s*purchase/i.test(el.textContent || ''));

    if (oneTimeOption) {
      let otpBadge = oneTimeOption.querySelector('.rally-otp-save-badge');
      const otpText = pack === '24-Pack' ? '10% OFF' : pack === '48-Pack' ? '20% OFF' : '';

      if (otpText) {
        if (!otpBadge) {
          otpBadge = document.createElement('span');
          otpBadge.className = 'rally-otp-save-badge';

          const label = oneTimeOption.querySelector('.appstle_one_time_text, .appstle_radio_label') || oneTimeOption.firstElementChild;
          if (label && label.parentNode) {
            label.insertAdjacentElement('afterend', otpBadge);
          } else {
            oneTimeOption.appendChild(otpBadge);
          }
        }
        otpBadge.textContent = otpText;
      } else if (otpBadge) {
        otpBadge.remove();
      }
    }

    subOption.querySelectorAll('.rally-effective-sub-detail, .rally-sub-support-copy')
      .forEach((el) => el.remove());

    const box = document.createElement('div');
    box.className = 'rally-sub-support-copy';

    const lines = [cfg.first, cfg.ongoing];
    if (cfg.freeShipping) lines.push('Free shipping');
    lines.push('Skip, modify, or cancel anytime');

    box.innerHTML = lines.map((line) => '<div>✓ ' + line + '</div>').join('');

    const frequencyWrap =
      subOption.querySelector('.appstle_subscription_frequency_wrapper') ||
      subOption.querySelector('.appstle_frequency_wrapper');

    const select = subOption.querySelector('select');
    const anchor = frequencyWrap || (select ? select.parentElement : null);

    if (anchor && anchor.parentNode) {
      anchor.insertAdjacentElement('afterend', box);
    } else {
      subOption.appendChild(box);
    }
  }

  function schedule(scope) {
    if (!scope) return;
    const generation = (state.get(scope) || 0) + 1;
    state.set(scope, generation);

    [0, 150, 400, 850, 1400].forEach((delay) => {
      setTimeout(() => render(scope, generation), delay);
    });
  }

  function init() {
    document.querySelectorAll('.product__info-container').forEach(schedule);

    document.addEventListener('change', (event) => {
      const radio = event.target.closest?.('.product-form__input--button input[type="radio"]');
      if (!radio) return;
      schedule(radio.closest('.product__info-container'));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
